import HomeSectionTitle from "./components/home-section-title";
import { useGSAP } from "@gsap/react";
import { useRef, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ButtonOutline from "@/components/ui/button-outline";
import HomeSectionDescription from "./components/home-section-description";

const HomeContact = () => {
  const bgRef = useRef<HTMLDivElement>(null);
  const contentsRefs = useRef<HTMLDivElement[]>([]);

  // 이유를모르겠음 일단 설정..
  useEffect(() => {
    const timeout = setTimeout(() => {
      ScrollTrigger.refresh();
    }, 100);

    return () => clearTimeout(timeout);
  }, []);

  useGSAP(() => {
    const bg = bgRef.current;
    const contents = contentsRefs.current;

    gsap
      .timeline({
        scrollTrigger: {
          trigger: bg,
          start: "top 70%",
          toggleActions: "play none none reverse",
        },
      })
      .fromTo(
        bg,
        { opacity: 0, y: 100 },
        { opacity: 1, y: 0, duration: 1.0, ease: "power3.out" }
      )
      .fromTo(
        contents,
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 0.8, ease: "power3.out" },
        "-=0.7"
      );
  }, []);

  return (
    <div className="flex items-center relative  w-full ">
      <div
        ref={bgRef}
        className="absolute grayscale  inset-0 z-0   bg-cover  bg-bottom   "
        style={{
          backgroundImage: "url(/img/hero/b9.jpg)",
        }}
      >
        <div className="absolute bottom-0 w-full left-0 h-full z-0 bg-linear-to-b from-transparent via-[#171717]/20 to-[#171717]"></div>

        <div className="absolute bottom-0 w-full left-0 h-1/2 top-0 z-0 bg-linear-to-b to-transparent via-[#171717]/80 from-[#171717]"></div>
        <div className="absolute bottom-0 w-full left-0 h-full top-0 z-0 bg-linear-to-l to-transparent via-[#171717]/50 from-[#171717]"></div>
      </div>

      <div className="grid-layout mb-5 grid md:grid-cols-2  py-25    relative">
        <div
          className="z-2  w-full flex flex-col gap-10"
          ref={(el) => (contentsRefs.current[0] = el!)}
        >
          <HomeSectionTitle className="mb-0 pb-0">
            프로젝트의 목표를 <br />
            함께 완성해 나갈 동료가 되겠습니다
          </HomeSectionTitle>
          <HomeSectionDescription className="max-w-[500px] ">
            <p>
              단순히 코드를 작성하는 것을 넘어, 비즈니스의 성공을 함께 고민하는
              동료를 찾으신다면, 기꺼이 그 여정에 함께하고 싶습니다.
            </p>
          </HomeSectionDescription>
          <div className="inline-block relative">
            <div className="flex divide-x divide-zinc-50/20    text-zinc-300  mb-10 after:bg-zinc-600 after:top-0 after:absolute after:left-0">
              {/* <SubNav />
               */}
              <div className="text-sm flex flex-col gap-1  pl-5 border-l border-border">
                <div className="">010 5027 8530</div>
                <div className="">squirrel309@naver.com</div>
              </div>
            </div>
            <div className="mt-20">
              <ButtonOutline name="응원 메세지 남기기" path="/guestboard" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeContact;
